<template>
    <v-card tile :class="{'fill-height' : $vuetify.breakpoint.smAndUp }">
        <v-toolbar
            dark
            color="primary"
            flat
            tile
        >
            <v-btn
                @click="$emit('update:basketVisible', false)"
                color="primary"
                class="basket-btn no-focus px-0"
                depressed
                :ripple="false"
                width="100%"
            >
                <span>
                    Basket
                </span>
                <v-icon>mdi-basket</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="px-0 pt-0" style="height: 500px; margin-bottom: 47px;">
            <v-list class="pt-0">
                <div
                    v-for="({title, quantity, displayOptions = []}, index) in basketItems"
                    :key="`${title}-${index}`"
                >
                    <v-list-item
                        @click="selectBasketItem(index)"
                        class="basketItem"
                        :ripple="{ class: 'primary-background', center: true }"
                        :class="[{ itemUpdated: basketItemUpdated === index }]"
                    >
                        <v-list-item-icon class="my-0 mr-5 d-block align-self-center">
                            <span class="d-inline-block font-weight-bold" style="min-width: 18px;">{{ quantity }}</span>
                            <span class="grey--text ml-3">x</span>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">{{ title }}</v-list-item-title>
                            <v-list-item-subtitle v-for="(displayOption, index) in displayOptions" :key="index">
                                {{ displayOption.label }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider
                        :key="index"
                    />
                </div>
            </v-list>
        </v-card-text>
        <v-toolbar tile style="position: fixed; bottom: 0; width: 100%;">
            <v-btn
                color="primary"
                depressed
                style="width: 100%;"
                @click="checkout = true"
                :ripple="false"
            >
                <span>Checkout</span>
            </v-btn>
            <v-spacer />
        </v-toolbar>
        <DialogCheckout :checkout.sync="checkout" />
    </v-card>
</template>
<script>
import DialogCheckout from '@/components/DialogCheckout';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'BasketList',

  components: {
    DialogCheckout,
  },

  data: () => ({
    checkout: false,
  }),

  computed: {
    ...mapGetters([
      'basketItems',
    ]),

    ...mapState({
      basketItemUpdated: (state) => state.basket.basketItemUpdated,
    }),

    navShowDialogCheckout() {
      return this.$route.meta.showCheckoutDialog;
    },
  },

  watch: {
    async checkout(newValue) {
      if (newValue) {
        await this.$router.push({ name: 'checkout' });
      } else if (this.navShowDialogCheckout) {
        this.$router.back();
      }
    },

    navShowDialogCheckout(newNavShowDialogCheckout) {
      if (!newNavShowDialogCheckout) {
        this.checkout = false;
      }
    },
  },

  methods: {
    ...mapActions([
      'selectBasketItem',
    ]),
  },
};
</script>

<style lang="scss">
  .basketItem.itemUpdated {
    animation: highlight .6s ease-out;
  }

  @keyframes highlight {
    0% {
      background: rgba(183, 28, 28, .4);
    }

    50% {
      background: rgba(183, 28, 28, .1);
    }

    100% {
      background: transparent;
    }
  }
</style>
